import { ProfileContext } from './ProfileContext';
import { genericHookContextBuilder } from '../util/genericHookContextBuilder';
import { useCallback, useContext, useState } from 'react';

function useStopWatch() {
    const { availableGame } = useContext(ProfileContext);
    const [plusTime, setPlusTime] = useState(availableGame?.penalties ?? 0);

    const wrongAnswer = useCallback(
        (savePenalty) => {
            setPlusTime(plusTime + 1);
            savePenalty(plusTime + 1, availableGame?.token);
        },
        [plusTime],
    );

    const saveHint = useCallback(
        (savePenalty) => {
            setPlusTime(plusTime + 2);
            savePenalty(plusTime + 2, availableGame?.token);
        },
        [plusTime],
    );

    const saveSolutionPenalty = useCallback(
        (savePenalty) => {
            setPlusTime(plusTime + 5);
            savePenalty(plusTime + 5, availableGame?.token);
        },
        [plusTime],
    );

    const state = {
        plusTime,
    };
    return {
        ...state,
        setPlusTime,
        wrongAnswer,
        saveHint,
        saveSolutionPenalty,
    };
}

export const { ContextProvider: StopWatchContextProvider, Context: StopWatchContext } =
    genericHookContextBuilder(useStopWatch);
